import css from 'styled-jsx/css';

const styles = css.global`

body {
    -webkit-font-smoothing: antialiased;
}

#hero-santander-financiamentos {
    overflow: hidden;
    background: #ec0000;
}


#hero-santander-financiamentos .bg-hero img {
    width: 100%;
    object-fit: contain;
    height: calc(100vh - 58px);
    position: absolute;
    max-height: 510px;
    min-height: 408px;
}

#hero-santander-financiamentos .fade-hero-santander {
    width: 100%;
    height: calc(100vh - 58px);
    position: absolute;
    max-height: 510px;
    min-height: 408px;
    background-color: black;
    opacity: .4;
}

#hero-santander-financiamentos .ctn-home-24 {
    position: relative;
    max-width: 530px;
}

#hero-santander-financiamentos .hero-contain {
    height: calc(100vh - 58px);
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-end;
    gap: 24px;
    padding-top: 40px;
    padding-bottom: 20px;
    max-height: 510px;
    min-height: 408px;
}

#hero-santander-financiamentos .hero-title {
    font-family: "SantanderHeadline";
    font-size: 32px;
    font-style: normal;
    font-weight: 400;
    line-height: 48px;
    color: #FFFFFF;
    max-width: 230px;
}

#hero-santander-financiamentos .hero-sub-title {
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
    color: #FFFFFF;
}

#hero-santander-financiamentos .hero-buttons {
    display: flex;
    flex-direction: column;
    gap: 17px;
    width: 100%;
    margin-bottom: 30px;
}

#hero-santander-financiamentos .hero-buttons a {
    width: 100%;
    max-width: 210px;
    margin: auto;
    border-radius: 80px;
    height: 50px;
    font-size: 20px;
    font-weight: 600;
    padding-bottom: 5px;
}

#hero-santander-financiamentos .img-hero-desk {
    display: none;
}

@media (min-width: 600px) {
    #hero-santander-financiamentos .bg-hero picture {
        position: absolute;
        height: 481px;
        width: 100%;
        left: 50%;
        transform: translate(-50%, 0);
    }

    #hero-santander-financiamentos .fade-hero-santander,
    #hero-santander-financiamentos .bg-hero img {
        /* height: calc(100vh - 140px);
        min-height: 460px; */
        position: initial;
        height: 481px;
    }

    #hero-santander-financiamentos .hero-contain {
        align-items: flex-start;
        padding-top: 48px;
        padding-bottom: 50px;
        /* height: calc(100vh - 140px);
        min-height: 490px; */
        justify-content: flex-end;
        height: 481px;
    }

    #hero-santander-financiamentos .hero-title {
        font-size: 64px;
        line-height: 120%;
        width: 100%;
        max-width: 832px;
        z-index: 2;
        position: relative;
        max-width: 410px;
    }

    #hero-santander-financiamentos .hero-sub-title {
        font-size: 32px;
        line-height: 120%;
        width: 100%;
        max-width: 716px;
        margin-top: 16px;
        z-index: 2;
        position: relative;
    }

    #hero-santander-financiamentos .hero-buttons {
        align-items: flex-start;
        gap: 16px;
        z-index: 2;
        margin-bottom: 0;
    }

    #hero-santander-financiamentos .hero-buttons a {
        margin: 0;
    }


}

@media (min-width: 800px) {
    #hero-santander-financiamentos .ctn-home-24 {
        max-width: 720px;
        padding-right: 45px;
        padding-left: 45px;
    }
    
    #hero-santander-financiamentos .hero-buttons {
        padding-left: 0;
    }

    #hero-santander-financiamentos .hero-buttons a {
        max-width: 220px;
    }
}

@media (min-width: 992px) {
 #hero-santander-financiamentos .hero-title {
        max-width: 610px;
    }
}

@media (min-width: 1281px) {
    #hero-santander-financiamentos .ctn-home-24 {
        max-width: 905px;
        padding-right: 0;
        padding-left: 0;
    }
    
    #hero-santander-financiamentos .hero-buttons a {
        max-width: 272px;
    }
}

@media (min-width: 1360px) {
    #hero-santander-financiamentos .bg-hero img {
        object-fit: cover;
    }

}`;

export default styles;